<template>
    <b-modal
        id="housecataloguemodal"
        title="Import Full Catalogue"
        @hidden="resetImport"
        :ok-disabled="importBusy"
        ok-title="Upload"
        @ok="handleImport"
    >
        <div class="mb-3">
            <a :href="route('admin.houses.components.import-catalogue.template')" class="btn btn-outline-secondary btn-sm">
                <i class="fas fa-download mr-1"></i> Download Template
            </a>
            <small class="d-block text-muted mt-1">
                Columns: ITEM, DEFECT GROUP, DEFECT TYPE, PICTURE. Leave ITEM/DEFECT GROUP blank on a row to reuse the value from the row above.
            </small>
        </div>

        <b-form-group label="Excel File (.xlsx / .xls)">
            <b-form-file v-model="importFile" accept=".xlsx,.xls" :disabled="importBusy"></b-form-file>
        </b-form-group>

        <div v-if="importBusy" class="d-flex align-items-center text-primary">
            <b-spinner small class="mr-2"></b-spinner>
            Importing… this can take a moment.
        </div>
        <div v-else-if="importStatus === 'completed'" class="text-success">
            <i class="fas fa-check-circle mr-1"></i> Import completed — {{ importProcessed }} defects added.
        </div>
        <div v-else-if="importStatus === 'failed'" class="text-danger">
            <i class="fas fa-times-circle mr-1"></i> Import failed: {{ importError }}
        </div>
    </b-modal>
</template>

<script>
export default {
    data(){
        return this.initData();
    },
    methods: {
        initData(){
            return {
                importFile: null,
                importBusy: false,
                importStatus: null,
                importProcessed: 0,
                importError: null,
            }
        },
        openModal(){
            this.$bvModal.show('housecataloguemodal');
        },
        resetImport(){
            this.importFile = null;
            this.importBusy = false;
            this.importStatus = null;
            this.importProcessed = 0;
            this.importError = null;
        },
        async handleImport(bvModalEvt){
            bvModalEvt.preventDefault();
            if (!this.importFile) {
                this.$swal('Please select a file.', '', 'warning');
                return;
            }
            this.importBusy = true;
            this.importStatus = null;
            const fd = new FormData();
            fd.append('file', this.importFile);
            try {
                const { data } = await axios.post(route('admin.houses.components.import-catalogue'), fd);
                this.importBusy = false;
                this.importStatus = data.status;
                this.importProcessed = data.processed_rows;
                this.importError = data.error_message;
                if (data.status === 'completed') {
                    reloadTable();
                }
            } catch (e) {
                this.importBusy = false;
                this.importStatus = 'failed';
                this.importError = e.response?.data?.message || 'Upload failed.';
            }
        },
    }
}
</script>
